import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-guests';

const fuzzy = (merchantId, branchId, userName) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/guests`, {
		userName,
	});
};

const list = (merchantId, branchId, userName, phone, email, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/page-guests`, {
		userName,
		phone,
		email,
		page,
		pageSize,
	});
};

const post = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/guests`, data);
};

export default {
	fuzzy,
	list,
	post,
};
